export enum USER_TYPE {
  CUSTOMER = 'C',
  EMPLOYEE = 'E',
}
